export const TeamChatReferenceBadgeTestIds = {
  BADGE: 'team-chat-reference-badge.pill',
};
